import { makeStyles } from "@material-ui/core/styles";

/**
 * Styles for the new RAM Portal adoption modal shown to RAM Live customers
 * with the RAM_LIVE_VISIBLE feature flag enabled.
 */
export const useStyles = makeStyles((theme) => ({
  dialog: {
    border: "none",
    padding: 0,
    margin: "auto",
    background: "transparent",
    maxWidth: "none",
    overflow: "visible",
    "&::backdrop": {
      background: "rgba(0,0,0,.35)",
      backdropFilter: "blur(6px)",
    },
    "&[open]:not(:modal)": {
      position: "fixed",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      maxHeight: "none",
      background: "rgba(0,0,0,.35)",
      backdropFilter: "blur(6px)",
      zIndex: 9999,
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "100dvh",
      overflowY: "auto",
      margin: "12px auto",
      "&[open]:not(:modal)": {
        alignItems: "flex-start",
        padding: "12px 0",
        overflowY: "auto",
      },
    },
  },
  modal: {
    position: "relative",
    background: "#fff",
    width: 1100,
    maxWidth: "95%",
    borderRadius: 28,
    boxShadow: "0 30px 80px rgba(0,0,0,.18)",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "calc(100dvh - 24px)",
      overflowY: "auto",
      borderRadius: 20,
    },
  },
  content: {
    display: "flex",
    alignItems: "center",
    padding: 40,
    paddingBottom: 0,
    paddingRight: 0,
    overflow: "hidden",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      padding: 24,
      paddingBottom: 0,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "44px 20px 20px",
      overflow: "visible",
    },
  },
  text: {
    flex: 1,
  },
  subtitle: {
    fontSize: 13,
    letterSpacing: 1.2,
    color: "#888",
    marginBottom: 10,
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      letterSpacing: 1,
      marginBottom: 8,
    },
  },
  heading: {
    fontSize: 36,
    lineHeight: 1.1,
    fontWeight: 600,
    color: "#171633",
    margin: "0 0 20px",
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    "@media (max-width: 900px)": {
      fontSize: 28,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 22,
      lineHeight: 1.2,
      margin: "0 0 14px",
    },
  },
  highlight: {
    color: "#e5007e",
  },
  description: {
    fontSize: 18,
    lineHeight: 1.6,
    color: "#444",
    marginBottom: 28,
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    fontWeight: 400,
    "@media (max-width: 900px)": {
      fontSize: 16,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
      lineHeight: 1.5,
      marginBottom: 20,
    },
  },
  cta: {
    display: "inline-block",
    background: "#e5007e",
    color: "#fff",
    padding: "14px 28px",
    borderRadius: 999,
    fontSize: 18,
    fontWeight: 600,
    textDecoration: "none",
    transition: "all .2s ease",
    marginBottom: 19,
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    "&:hover": {
      background: "#c7006d",
      color: "#fff",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
      padding: "12px 22px",
      marginBottom: 0,
      width: "100%",
      boxSizing: "border-box",
      textAlign: "center",
    },
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    overflow: "hidden",
    "@media (max-width: 900px)": {
      width: "100%",
      justifyContent: "center",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  image: {
    width: "120%",
    maxWidth: "none",
    "@media (max-width: 900px)": {
      width: "100%",
    },
  },
  closeButton: {
    position: "absolute",
    top: 18,
    right: 20,
    width: 36,
    height: 36,
    border: "none",
    background: "rgba(255,255,255,0.9)",
    fontSize: 22,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#666",
    zIndex: 2,
    "&:hover": {
      color: "#e5007e",
    },
    [theme.breakpoints.down("sm")]: {
      top: 10,
      right: 10,
      width: 44,
      height: 44,
      fontSize: 26,
      borderRadius: 8,
      boxShadow: "0 2px 8px rgba(0,0,0,.12)",
    },
  },
}));
